// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class CollectionEditHeaderImageModalRecord extends Immutable.Record({
  droppedFile: null,
  savedImageUrl: String()
}) {
  // No methods
}

CollectionEditHeaderImageModalRecord.reviver = keyedReviver(CollectionEditHeaderImageModalRecord, {
  // No nested data structures
})

module.exports = CollectionEditHeaderImageModalRecord
